import { render, staticRenderFns } from "./SKUSetting.vue?vue&type=template&id=5d19a421"
import script from "./SKUSetting.vue?vue&type=script&lang=js"
export * from "./SKUSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports